import React, { useEffect, useState } from 'react';
import { Card, Input, Row, Select, Spin } from 'antd';
import { useQuery } from 'react-query';
import { FormInstance } from 'antd/lib/form';

import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import { getProposalThirdParty, ProposalTPResponse } from 'services/proposal';
import { getScoringGridListByCriteria } from 'services/scoring';
import InputCurrency from 'components/InputCurrency';

export type TabScoringProps = {
  objectid?: number;
  object?: string;
  form?: FormInstance;
  requestedamount?: number;
  currcode?: string;
  entityName?: string;
  entityReference?: string;
  setSuccessful?: any;
};

const TabScoring = ({
  objectid,
  object,
  requestedamount,
  currcode,
  entityName,
  entityReference,
  form,
  setSuccessful,
}: TabScoringProps) => {
  const { data: scoringGrid, isFetching } = useQuery(
    [
      'getScoringGridListByCriteria',
      { objectid, object, requestedamount, currcode },
    ],
    () =>
      getScoringGridListByCriteria({
        objectid: objectid!,
        objecttype: object!,
      }).then((res) => {
        if (res.list.length > 0) {
          form?.setFieldsValue({
            gridid: res.list![0].scoid,
            requestedamount: requestedamount,
            currcode: currcode,
            event: 'tabScoring',
          });
        }
        return res.list || [];
      }),
    {
      enabled: !!objectid && !!object,
    }
  );

  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);

  // eslint-disable-next-line no-unused-vars
  const [role, setRole] = useState('CLIENT');

  const handleRoleChange = (role: string) => {
    if (object === 'PROPOSAL') {
      getProposalThirdParty({ ctrid: objectid!, role: role! }).then((res) => {
        form?.setFieldsValue({ tpid: null });
        setThirdParties(res.list);
        if (res.list.length > 0) {
          form?.setFieldsValue({
            tpid: res.list![0].tpid,
            tpname: res.list![0].tpname,
            tpreference: res.list![0].tpreference,
          });
        }
      });
    } else {
      // object = THIRDPARTY :
      let TP: ProposalTPResponse = {
        tpid: objectid ?? 0,
        tpname: entityName ?? '',
        tpreference: entityReference ?? '',
        tprole: 'CLIENT',
      };
      let TPList: Array<ProposalTPResponse> = [];
      TPList.push(TP);
      setThirdParties(TPList);
      form?.setFieldsValue({
        tpid: objectid,
        tpname: entityName ?? '',
        tpreference: entityReference ?? '',
      });
    }
  };

  useEffect(()=>{
    handleRoleChange("CLIENT")
  },[])

  const [thirdParties, setThirdParties] = useState<Array<ProposalTPResponse>>(
    []
  );

  return (
    <DF.Provider pagcode="tabscoring">
      <Spin spinning={isFetching}>
        <Card size="small" type="inner" title="Scoring Grid" bordered>
          <Row gutter={[8, 8]}>
            <FormInput col xs={8} name="gridid" rules={[{ required: true }]}>
              <Select>
                {scoringGrid?.map((data) => (
                  <Select.Option key={data.scoid} value={data.scoid}>
                    {data.scolabel}
                  </Select.Option>
                ))}
              </Select>
            </FormInput>
            <FormInput col xs={4} name="tprole" rules={[{ required: true }]}>
              <ParListSelect
                parcode="TPMAINROLE"
                forcedValue={role}
                onChange={(role) => {
                  setRole(role);
                  handleRoleChange(role);
                }}
              />
            </FormInput>

            <FormInput col xs={4} name="currcode" rules={[{ required: true }]}>
              <ParListSelect parcode="CURRENCY" />
            </FormInput>
            <FormInput
              col
              xs={6}
              name="requestedamount"
              rules={[{ required: true }]}
            >
              <InputCurrency currcode={form?.getFieldValue('currcode')} hideCurrcode></InputCurrency>
            </FormInput>
          </Row>
          <Row gutter={[8, 8]}>
            <FormInput col xs={12} name="tpid" rules={[{ required: true }]}>
              <Select>
                {thirdParties?.map((data: any) => (
                  <Select.Option key={data.tpid} value={data.tpid}>
                    {data.tpname}
                  </Select.Option>
                ))}
              </Select>
            </FormInput>
            <FormInput xs={5} name="referenceyear" rules={[{ required: true }]}>
              <Input />
            </FormInput>
          </Row>
        </Card>
      </Spin>
    </DF.Provider>
  );
};
export default TabScoring;
